import { IColum } from "../../utils/copyToClipboardInXlsFormat";
import { WITHDRAWALS_COLUMNS } from "../FundedCompliance/components/Withdrawals/constants";

export const ACCOUNTS_MAIN_DATA_COLUMNS: Array<IColum> = [
  {
    by: "id",
    title: "Evaluation account ID",
    path: "account.id",
  },
  {
    by: "email",
    title: "Email",
    path: "account.email",
  },
  {
    by: "name",
    title: "Name",
    path: "account.name",
  },
  {
    by: "address",
    title: "Address",
    path: "account.address",
  },
  {
    by: "phone",
    title: "Phone",
    path: "account.phone",
  },
];

export const ACTIVE_WITHDRAWALS_COLUMNS: Array<IColum> = [...WITHDRAWALS_COLUMNS].filter(
  (col) => !["Measure taken", "Measure timestamp", "Entries ID"].includes(col.title)
);
